import * as React from "react";
import { Helmet } from "react-helmet";
import Header from "@components/Header";
import Screen from "@components/Screen";
import TextLeft from "@components/TextLeft";
import ImageRight from "@components/ImageRight";
import Button from "@components/Button";
import "@styles/main.css";
import * as classess from "@styles/screen.module.css";
import { Img1, Img2, Img3, Img4, Img5, Img6, Img7 } from "@images/images";
import Card from "@components/Card";
import Footer from "@components/Footer";
// markup

const IndexPage = () => {
  return (
    <main className="main">
      <Helmet>
        <meta charSet="utf-8" />
        <title>SteganoLaby - Strona główna</title>
      </Helmet>
      {/* first screen start */}
      <Screen counter={1} first={true} id="home">
        <Header />
        <section className={classess.firstScreenMainContent}>
          <div className={classess.left}>
            <TextLeft
              className={classess.column2}
              header="steganografia"
              textDescribe="Wykorzystaj metodę najmniej znaczącego bitu w celu zakodowania/odkodowania tajnej wiadomości w pliku graficznym BMP."
            />
            <Button navigateTo="theory" text="wprowadzenie" counter={1} />
          </div>
          <div className={classess.right}>
            <ImageRight className={classess.column2} />
          </div>
        </section>
      </Screen>
      {/* first screen stop */}
      {/* second screen start */}
      <Screen counter={2} id="theory">
        <section className={classess.otherScreenEven}>
          <h1>Na czym polega metoda LSB?</h1>
          <figure>
            <img src={Img1} alt="metoda lsb" />
          </figure>
          <p>
            LSB to inaczej metoda najmniej znaczącego bitu. Jest najczęściej
            wykorzystywaną metodą ukrywania treści w plikach graficznych.
            Działanie algorytmu polega na zmianie najmniej znaczącego bitu
            każdego piksela na bity odpowiadające treści ukrywanej wiadomości.
          </p>
          <Button
            navigateTo="encode-instruction"
            text="zakodowywanie"
            counter={2}
          />
        </section>
      </Screen>
      {/* second screen stop */}
      {/* third screen start */}
      <Screen counter={3} id="encode-instruction">
        <section className={classess.otherScreenOdd}>
          <h1>Zakoduj wiadomość</h1>
          <p>W trzech prostych krokach:</p>
          <div className={classess.row}>
            <Card
              counter={3}
              image={Img3}
              altText="wgrywanie pliku"
              titleText="Wgraj swoją grafikę"
              descriptionText='Przeciągnij i upuść swoją grafikę w wyznaczonym miejscu lub skorzystaj z przycisku "Wczytaj grafikę"'
            />
            <Card
              counter={3}
              image={Img6}
              altText="Dodaj wiadomość"
              titleText="Dodaj wiadomość"
              descriptionText='Wprowadź tekst jaki chcesz ukryć w grafice.'
            />
            <Card
              counter={3}
              image={Img5}
              altText="Ustaw najmniej znaczący bit"
              titleText="Ustaw najmniej znaczący bit"
              descriptionText='Za pomocą suwaków zaznacz najmniej znaczące bity każdej ze składowej RGB.'
            />
          </div>
          <Button
            navigateTo="decode-instruction"
            text="odkodowywanie"
            counter={3}
          />
        </section>
      </Screen>
      {/* third screen stop */}
      {/* fourth screen start */}
      <Screen counter={4} id="decode-instruction">
        <section className={classess.otherScreenEven}>
        <h1>Odkoduj wiadomość</h1>
          <p>W trzech prostych krokach:</p>
          <div className={classess.row}>
            <Card
              counter={4}
              image={Img3}
              altText="wgrywanie pliku"
              titleText="Wgraj swoją grafikę"
              descriptionText='Przeciągnij i upuść swoją grafikę w wyznaczonym miejscu lub skorzystaj z przycisku "Wczytaj grafikę"'
            />
            <Card
              counter={4}
              image={Img5}
              altText="Ustaw najmniej znaczący bit"
              titleText="Ustaw najmniej znaczący bit"
              descriptionText='Za pomocą suwaków zaznacz najmniej znaczące bity każdej ze składowej RGB.'
            />
            <Card
              counter={4}
              image={Img4}
              altText="Odczytaj wiadomość"
              titleText="Odczytaj wiadomość"
              descriptionText='W wyznaczonym miejscu pojawi się wiadomość ukryta w grafice.'
            />
          </div>
        </section>
      </Screen>
      {/* fourth screen stop */}
      <Footer counter={5}/>
    </main>
  );
};

export default IndexPage;

// <TextLeft
//             className={classess.column2}
//             header="steganografia"
//             textDescribe="Wykorzystaj metodę najmniej znaczącego bitu w celu zakodowania/odkodowania tajnej wiadomości w pliku graficznym BMP."
//           />
//           <ImageRight className={classess.column2} />
